import { render, staticRenderFns } from "./ProjectPlace.vue?vue&type=template&id=4fc943b6&scoped=true&"
import script from "./ProjectPlace.vue?vue&type=script&lang=js&"
export * from "./ProjectPlace.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlace.vue?vue&type=style&index=0&id=4fc943b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc943b6",
  null
  
)

export default component.exports